// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "client-editor/" + ({"3250":"CompactMobile","3697":"ListLayout","4213":"Calendar","5200":"wix-i18n-config_intl-pluralrules","6846":"CardsMobile","6858":"EmptyState","6894":"wix-i18n-config_intl-relativetimeformat","7262":"SideBySide","8845":"SingleEvent","9438":"Cards"}[chunkId] || chunkId) + ".chunk.min.js";
};